import { ReactNode } from 'react';

import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import {
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import {
  DE_DIRECT_BASE_PATHNAME,
  UK_DIRECT_BASE_OB_LINK_PATHNAME,
  UK_DIRECT_BASE_PATHNAME,
  UK_PREVIEW_LINK_BANK_PATHNAME,
} from '../constants';

export const DynamicBrowserRouter = ({ children }: { children: ReactNode }) => {
  const isDirectCustomer =
    window.location.pathname.includes(`/${UK_DIRECT_BASE_PATHNAME}`) ||
    window.location.pathname.includes(`/${DE_DIRECT_BASE_PATHNAME}`);
  const isPublicPage =
    window.location.pathname.includes(`/${UK_DIRECT_BASE_OB_LINK_PATHNAME}`) ||
    window.location.pathname.includes(`/${UK_PREVIEW_LINK_BANK_PATHNAME}`);

  const router = createBrowserRouter(
    createRoutesFromElements(<Route path="/*" element={children} />),
    {
      basename: `/${isDirectCustomer || isPublicPage ? '' : 'partner-signup'}`,
    },
  );

  return <RouterProvider router={router} />;
};
